import type { FirebaseMessagingAPIOptions } from './types/firebase-config.types';

const firebaseConfigDev: FirebaseMessagingAPIOptions = {
  apiKey: 'AIzaSyCqwD0J4i28jcOsJsnJMbk52W4bceV_jho',
  authDomain: 'pushme-dev.firebaseapp.com',
  projectId: 'pushme-dev',
  storageBucket: 'pushme-dev.appspot.com',
  messagingSenderId: '211830611910',
  appId: '1:211830611910:web:d306800dd68a78f5685cc7',
  measurementId: 'G-TWJ5QLYC7Z',

  vapidKey:
    'BEFZmeWcfkKfuJwgDc7Gkwnrxfju5_thTfNArRnlHB8w_MkTlqRzUTgj5PTicMTr-CFuE0U7mf9kCHE6if6x8Bw',
};

const firebaseConfigProd: FirebaseMessagingAPIOptions = {
  apiKey: 'AIzaSyB49_iQUsLQhd-TGUHMl8P1PSTH4o7YRro',
  authDomain: 'mailnewspush.firebaseapp.com',
  databaseURL: 'https://mailnewspush.firebaseio.com',
  projectId: 'mailnewspush',
  storageBucket: 'mailnewspush.appspot.com',
  messagingSenderId: '699287244129',
  appId: '1:699287244129:web:506c1ab3845df13bf48920',

  vapidKey:
    'BOGUE03dPBcwQZZfT0xnppk9pvx85EWYM8e6U2KCeIONdbqK3Kz_NXvkJ7GUFcz9Y6eIWst8F1ODlva5TveClHw',
};

export const configs = {
  dev: firebaseConfigDev,
  prod: firebaseConfigProd,
};

export const getConfigFCM = (env: 'dev' | 'prod') => configs[env];
